<template>
    <div class="redesign-capped-agent-list">
        <div
            v-for="item in visibleItems"
            :key="item.id"
            class="redesign-capped-agent-list__item"
            :title="item.name"
        >
            {{ item.name }}
        </div>
        <div
            v-if="overflowCount > 0"
            class="redesign-capped-agent-list__overflow"
        >
            ...{{ overflowCount }} {{ t('general.more') }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { CAPPED_AGENT_LIST_MAX_VISIBLE } from '@/components/RedesignBaseComponents/cappedAgentListConfig'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

type CappedListItem = {
    id: number | string
    name: string
}

const props = withDefaults(
    defineProps<{
        items: ReadonlyArray<CappedListItem>
        maxVisible?: number
        totalCount?: number
    }>(),
    {
        maxVisible: CAPPED_AGENT_LIST_MAX_VISIBLE
    }
)

const total = computed(() => props.totalCount ?? props.items.length)

const visibleItems = computed(() =>
    props.items.length > props.maxVisible
        ? props.items.slice(0, props.maxVisible)
        : props.items
)

const overflowCount = computed(() =>
    Math.max(0, total.value - visibleItems.value.length)
)
</script>

<style scoped lang="scss">
.redesign-capped-agent-list {
    @apply grid gap-x-4 gap-y-1 p-2;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-width: 360px;

    &__item {
        @apply truncate text-main-sm;
    }

    &__overflow {
        @apply text-main-sm text-center opacity-70 pt-1;
        grid-column: 1 / -1;
    }
}
</style>
